<template>
    <div class="footer-content">
        <div class="content">
            <div>
                <div class="title">หน้า</div>
                <div class="item" @click="handleClick('/')">
                    หน้าแรก
                </div>
                <div class="item" @click="handleClick('/service')">
                    บริการ
                </div>
                <div class="item" @click="handleClick('/about')">
                    เกี่ยวกับเรา
                </div>
                <div class="item" @click="handleClick('/contact')">
                    ติดต่อเรา
                </div>
            </div>
            <div>
                <div class="title">ติดต่อเรา</div>
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="bottom">
            Copyright 2026 © MONEYBAY COMPANY LIMITED All rights reserved
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.push(path);
    window.scrollTo(0, 0);
};
const list = [
    {
        content: "sys@get-moneyservices.com",
        index: 1,
    },
    {
        content: "+66 0925843514",
        index: 2,
    },
    {
        index: 3,
        content: "77 หมู่ที่ 1 ตำบลท่าเสา อำเภอเมืองอุตรดิตถ์ จ.อุตรดิตถ์ 53000",
    }
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 234px;
    background-color: #293038;

    .content {
        display: flex;
        justify-content: space-around;
        box-sizing: border-box;
        padding-top: 32px;

        .title {
            font-weight: bold;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 15px;
            margin-bottom: 15px;
        }

        .item {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 12px;
            margin-bottom: 15px;

            img {
                width: 26px;
                object-fit: cover;
                margin-right: 6px;
            }
        }
    }

    .bottom {
        height: 51px;
        background: #3F454B;
        font-weight: 500;
        font-size: 15px;
        color: #D7D7D7;
        line-height: 51px;
        text-align: center;
        margin-top: auto;
    }
}
</style>